export {
  mcubeApiKey,
  apiBaseUrl,
  phoneNumbers,
  audioAcknowledgementMessage,
  documentAcknowledgementMessage,
  imageAcknowledgementMessage,
};

const mcubeApiKey = { name: "mcubeApiKey", label: "API Key *", type: "text" };

const apiBaseUrl = {
  name: "apiBaseUrl",
  label: "API Base URL *",
  type: "text",
};

const phoneNumbers = {
  name: "phoneNumbers",
  label: "Phone Numbers",
  type: "inputFieldList",
  addLabel: "+ Add Phone Number",
  addPlaceholder: ""
};

const audioAcknowledgementMessage = {
  name: "audioAcknowledgmentMessage",
  label: "Audio Acknowledgement Message",
  type: "textArea",
  style: { fontSize: "13px", height: "80px" },
};

const documentAcknowledgementMessage = {
  name: "documentAcknowledgmentMessage",
  label: "Document Acknowledgement Message",
  type: "textArea",
  style: { fontSize: "13px", height: "80px" },
};

const imageAcknowledgementMessage = {
  name: "imageAcknowledgmentMessage",
  label: "Image Acknowledgement Message",
  type: "textArea",
  style: { fontSize: "13px", height: "80px" },
};
